"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'TopNav.Button'
});
schema.propTypes = {
  disabled: _reactDesc.PropTypes.bool.description('Defines if the button will be disabled'),
  emblem: _reactDesc.PropTypes.func.description('An emblem can be any of an Iconix icon, a badge, or an Avatar, and be used with or without accompanying text.').format('React Component'),
  expanded: _reactDesc.PropTypes.bool.description('Controls an "expander" icon on the right side of the button. Invalid if `withExpander` is not `true`.'),
  primaryText: _reactDesc.PropTypes.string.description('A prominent text'),
  secondaryText: _reactDesc.PropTypes.string.description('A less prominent text'),
  tooltipText: _reactDesc.PropTypes.string.description('Text to render in a tooltip when hovered over the element. Required if primary text is not provided.'),
  withExpander: _reactDesc.PropTypes.bool.description('Enables the "expander" icon on the right side of the element.'),
  counter: _reactDesc.PropTypes.number.description('Number to show in a red bubble at the top center of the button')
};
var _default = schema;
exports.default = _default;